var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.07283 9.76467C6.5747 9.26741 6.27148 8.59168 6.27148 7.83365C6.27148 6.31499 7.49473 5.09088 9.01252 5.09088C9.76362 5.09088 10.4549 5.39496 10.9444 5.89223",
    stroke: "#2E2E5D",
    strokeWidth: 1.29948,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7037 8.31982C11.5027 9.43738 10.6225 10.3193 9.50586 10.522",
    stroke: "#2E2E5D",
    strokeWidth: 1.29948,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.38298 12.4549C3.00813 11.3755 1.84379 9.79875 1 7.83308C1.85246 5.85873 3.02459 4.27337 4.4081 3.18527C5.78295 2.09718 7.36918 1.50635 9.01345 1.50635C10.6673 1.50635 12.2526 2.10584 13.6361 3.20173",
    stroke: "#2E2E5D",
    strokeWidth: 1.29948,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4662 5.10742C16.0622 5.89924 16.5863 6.8132 17.0273 7.83286C15.3232 11.7807 12.3119 14.1587 9.01383 14.1587C8.2662 14.1587 7.52896 14.0374 6.82031 13.8009",
    stroke: "#2E2E5D",
    strokeWidth: 1.29948,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.845 1L2.17969 14.6653",
    stroke: "#2E2E5D",
    strokeWidth: 1.29948,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.c9ef8be2371d5caafc16af70f580d14e.svg";
export { ForwardRef as ReactComponent };